<div class="card">
    <app-header titulo="Contas contábeis" descricao="Integração das contas contábeis"></app-header>

    <p-table [value]="contaContabeis" [globalFilterFields]="['cdEmpresaErp','cdFilialErp', 'cdContaErp', 'cdContaPims', 'deConta', 'cdGrupoErp', 'cdGrupoPims', 'deGrupo']"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        [rowsPerPageOptions]="[10, 20, 50, 100]" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" dataKey="cdContaErp"
        #dt>
        <ng-template pTemplate="caption">

            <div class="flex justify-content-end flex-wrap">

                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3 mr-3" pButton (click)="exportar()" style="font-size: 1.0rem"
                        [loading]="loadingSincronizar" icon="pi pi-file-excel" label="Exportar"></button>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <span class="p-input-icon-left ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                            placeholder="Pesquisar" />
                    </span>
                </div>
                <div class="flex align-items-center justify-content-center">
                    <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getAll()"
                        [loading]="loading"></button>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Empresa ERP</th>
                <th>Filial ERP</th>
                <th>Conta ERP</th>
                <th>Conta PIMS</th>
                <th>Descrição</th>
                <th>Grupo ERP</th>
                <th>Grupo PIMS</th>
                <th>Grupo Conta Contábil Descrição</th>
                <th>Dt Última Atualização</th>
                <th>Dt Recebido</th>
                <th>Status</th>
                <th>Dt Integrado</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-conta>
            <tr>
                <td>{{ conta.cdEmpresaErp }}</td>
                <td>{{ conta.cdFilialErp }}</td>
                <td>{{ conta.cdContaErp }}</td>
                <td>{{ conta.cdContaPims }}</td>
                <td>{{ conta.deConta }}</td>
                <td>{{ conta.cdGrupoErp }}</td>
                <td>{{ conta.cdGrupoPims }}</td>
                <td>{{ conta.deGrupo }}</td>
                <td>{{ conta.dtUltatu | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ conta.dtRecebido | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td><app-tag-status [status]="conta.fgStatusInteg"></app-tag-status></td>
                <td>{{ conta.dtIntegPims | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ conta.deMensagemInteg }}</td>
            </tr>
        </ng-template>
    </p-table>
</div>